// @flow
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import Theme from 'statsradio/themes';
import AgeRangeReaches from 'common/domain/AgeRangeReaches';
import { displayPercent } from 'common/components/Number';
import { DemographyPercent, DemographyPercentRow } from './DemographyPercentLayout';

const ChartContainer = styled.div`
  height: 220px;
  margin: ${props => props.theme.V3.metrics.margin.normal}px 0;
`;

interface Props {
  ageRangeReaches: AgeRangeReaches,

  t: any,
  theme: typeof Theme,
}

function AgeGroupPane({ ageRangeReaches, t, theme }: Props) {
  const data = ageRangeReaches.asPercent().map((r) => {
    const datum = { name: r.range };
    datum[t('percentage')] = r.reach;
    return datum;
  });

  const lessOld = ageRangeReaches.getPercentFor(['25-34', '35-44', '45-54']);
  const old = ageRangeReaches.getPercentFor(['35-44', '45-54', '55-64', '65+']);

  return (
    <React.Fragment>
      <ChartContainer>
        <ResponsiveContainer height="100%" width="100%">
          <BarChart data={data} barCategoryGap="25%">
            <CartesianGrid vertical={false} horizontal color={theme.V3.colors.surface} fontSize="20px" />
            <XAxis dataKey="name" axisLine={false} tickLine={false} />
            <YAxis
              width={40}
              interval={0}
              scale={'linear'}
              axisLine={false}
              tickFormatter={displayPercent}
              tickLine={false}
              type="number"
              domain={['dataMin - 0.01', 'dataMax + 0.05']} // - 0.01 is used to solve a glitch when percentage is small
            />
            <Tooltip formatter={label => displayPercent(label)} />
            <Bar dataKey={t('percentage')} fill={theme.V3.colors.age} />
          </BarChart>
        </ResponsiveContainer>
      </ChartContainer>
      <DemographyPercentRow>
        <DemographyPercent
          label={t('lessOld')}
          percent={lessOld}
          color={theme.V3.colors.age}
        />
        <DemographyPercent
          label={t('old')}
          percent={old}
          color={theme.V3.colors.age}
        />
      </DemographyPercentRow>
    </React.Fragment>
  );
}

export default translate('dashboard')(withTheme(AgeGroupPane));



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/demography/AgeGroupPane.js